import { lazy } from 'react';
import { ResetPasswordPage } from '../components/modal/ResetPasswordPage';
import { ResetPasswordCodePage } from '../components/modal/ResetPasswordCodePage';

// ----------------------------------------------------------------------

const LoginPage = lazy(() => import('../pages/Login.page'));
const LoginWithEmail = lazy(() => import('../pages/LoginWithEmail.page'));

// ----------------------------------------------------------------------

const LoginRoutes = [
    {
        path: '/login',
        element: <LoginPage />,
        layout: 'default',
        isAuthReq: true,
    },
    {
        path: '/forget-password',
        element: <LoginWithEmail />,
        isAuthReq: true,
    },
    {
        path: '/reset-password',
        element: <ResetPasswordPage />,
        isAuthReq: true,
    },
    {
        path: '/reset-password-code',
        element: <ResetPasswordCodePage />,
        isAuthReq: true,
    },
];

export { LoginRoutes };
